/**
 * stateの初期値設定
 */
export default {
  signupToken: null, // サインアップ手続き時に必要なtoken
  current: {
    campaign: {
      name: ''
    }
  },
  me: null,
  nowFileUploading: false,
  apiEnums: {},
  IsRedirectFromIg: false
};
